module.exports = __webpack_public_path__ + "images/upgrade-success-golfers-two.a30c82d123869fa9e35c227f09b02385.png";